import { useParams } from 'react-router-dom'
import { PacketEditor } from 'app/components/paperwork/PacketEditor'
import { usePacketEditor } from 'app/components/paperwork/usePacketEditor'

function PacketEditorRoute({ id }: { id: string }) {
  const props = usePacketEditor(id)
  return <PacketEditor {...props} />
}

export default function SettingsPacketEditor() {
  const { paperworkTemplateId = `` } = useParams()
  return <PacketEditorRoute key={paperworkTemplateId} id={paperworkTemplateId} />
}
